// CapaStatus Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { capaStatusConfig } from './capaStatusConfig';
import { createCapaStatusValidation } from './capaStatusValidation';

/**
 * Initialize the capaStatus module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  capaStatusConfig,
  createCapaStatusValidation
);

/**
 * Create the CapaStatusPage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const CapaStatusPage = createModulePage(
  initializedConfig,
  {
    displayName: 'CapaStatusPage',
    description: 'CAPA Status Management System - Manage CAPA statuses for tracking progress'
  }
);

export default CapaStatusPage;
